module.exports = __webpack_public_path__ + "static/media/BrokerPortal.f84fe816.svg";